import {
  commitMutation,
  graphql
} from 'react-relay';
import environment from '../Environment';

const mutation = graphql`
  mutation GenerateTableParametrageMutation($tableType: String!, $ccnId: String, $offerType: OfferTypeEnum!) {
    generateTableParametrage(tableType: $tableType, ccnId: $ccnId, offerType: $offerType) {
      ok
      error
      url
    }
  }
`;

export default ({ tableType, ccnId, offerType }, done) => {
  const variables = {
    tableType,
    ccnId,
    offerType
  };

  commitMutation(
    environment,
    {
      mutation,
      variables,
      onCompleted: (response) => {
        const { ok, token, url } = response.generateTableParametrage;
        done(ok, token, url);
      },
      onError: err => console.error(err)
    }
  );
};
